/**
 * Track an event in Heap
 * Note: Temporarily adding google analytics in here to see if it's
 *  viable to switch from heap. If we decide to stick with google analytics,
 *  we'll rename this function.
 */
function trackHeapEvent(eventName, options) {
    if (!eventName) {
        return;
    }

    window.heap?.track(eventName, options);

    // Send to google analytics so we can compare the viability of using it over heap
    // TODO: Clean up in FIT-4283
    window.gtag?.('event', eventName, options);
}

export default trackHeapEvent;
